import { FilterOperator } from '../model';
import { TranslationsKeys } from '../services';

/**
 * Translation keys for filter operators
 */
export const OPERATOR_LABELS: Record<FilterOperator, TranslationsKeys> = {
  [FilterOperator.EQUALS]: 'cairo.filterOperator.equals',
  [FilterOperator.NOT_EQUALS]: 'cairo.filterOperator.notEquals',
  [FilterOperator.IN]: 'cairo.filterOperator.in',
  [FilterOperator.NOT_IN]: 'cairo.filterOperator.notIn',
  [FilterOperator.STARTS_WITH]: 'cairo.filterOperator.startsWith',
  [FilterOperator.IS_EMPTY]: 'cairo.filterOperator.isEmpty',
  [FilterOperator.CONTAINS]: 'cairo.filterOperator.contains',
  [FilterOperator.NOT_CONTAINS]: 'cairo.filterOperator.notContains',
  [FilterOperator.EXISTS]: 'cairo.filterOperator.exists',
  [FilterOperator.NOT_EXISTS]: 'cairo.filterOperator.notExists',
};

/**
 * Get translation key for an operator
 */
export const getOperatorLabel = (operator: FilterOperator): TranslationsKeys =>
  OPERATOR_LABELS[operator] ?? operator;
